import { render, staticRenderFns } from "./StoryboardEditorPage.vue?vue&type=template&id=9baa29ce&scoped=true"
import script from "./StoryboardEditorPage.vue?vue&type=script&lang=js"
export * from "./StoryboardEditorPage.vue?vue&type=script&lang=js"
import style0 from "./StoryboardEditorPage.vue?vue&type=style&index=0&id=9baa29ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9baa29ce",
  null
  
)

export default component.exports